import React from "react";

export const RegionDetailContext = React.createContext(null);

export const useRegionDetailContext = () => {
  const context = React.useContext(RegionDetailContext);

  if (!context) throw new Error("Region Detail Context not provided!");

  return context;
};
